define('models/calendar/session/exercise/weight/set',[
    'underscore', 'backbone', 'utils',
    // services
    'services/user',
    'services/unit-converter'
], function(
    _, Backbone, U,
    // services
    User,
    UnitConverter
) {

    var MSet = Backbone.Epoxy.Model.extend({
        defaults: function() {
            return {
                reps: 0,
                rest: 0,
                load: this.defaultLoad()
            };
        },

        defaultLoad: function() {
           var loadUnit = this.get('ownerLoadUnit');//User.get('weightUnit');

           if (_.isEmpty(loadUnit))
              loadUnit = "lbs";

            return {
                unit: loadUnit,
                value: 0,
            };
        },

        initialize: function(attrs, options) {
            if (!this.get('load')) {
                this.set({ load: this.defaultLoad() });
            }
        },

        computeds: {
            loadUnit: {
                deps: ["load"],
                get: function(load) {
                    return load.unit;
                },
                set: function(val) {
                    return { load: _.extend({}, this.get("load"), { unit: val }) };
                }
            },
            loadValue: {
                deps: ["load"],
                get: function(load) {
                    return load.value;
                },
                set: function(val) {
                    return { load: _.extend({}, this.get("load"), { value: val }) };
                }
            },
            ownerLoadUnit: {
                deps: ["load"],
                get: function(unit) {
                    return User.getCurrentlySelectedUser().get("weightUnit");
                }
            },
            convertedLoadValue: {
                deps: ["load"],
                get: function(load) {
                    var displayUnit = User.get('weightUnit'),
                        loadUnit = load.unit,
                        value = parseFloat(load.value);

                    if (displayUnit && value && loadUnit) value = UnitConverter.convert(value, loadUnit, displayUnit);

                    return Math.round(value * 10) / 10;
                },
                set: function(val) {
                  var displayUnit = User.get('weightUnit'),
                      loadUnit = this.get('ownerLoadUnit'),
                      value = parseFloat(val),
                      convertedValue = UnitConverter.convert(value, displayUnit, loadUnit, true);
                      convertedValue = Math.round(convertedValue * 10) / 10;

                    this.set('loadValue', Number(convertedValue));
                    this.set('loadUnit', loadUnit);
                    return val;
                }
            },
            restMinutes: {
                deps: ["rest"],
                get: function(rest) {
                    return Math.floor(rest / 60);
                },
                set: function(minutes) {
                    minutes = parseInt(minutes) || 0;
                    var rest = this.get('rest') || 0,
                        oldMinutes = parseInt(this.get('restMinutes')) || 0;

                    return {
                        rest: rest + (minutes - oldMinutes) * 60
                    };
                }
            },
            restSeconds: {
                deps: ["rest"],
                get: function(rest) {
                    rest = rest % 60;
                    return rest < 10 ? '0' + rest : rest;
                },
                set: function(seconds) {
                    seconds = parseInt(seconds) || 0;
                    var rest = this.get('rest') || 0,
                        oldSeconds = parseInt(this.get('restSeconds')) || 0;

                    if (seconds > 59) seconds = 59;

                    return {
                        rest: rest + (seconds - oldSeconds)
                    };
                }
            },

            restValue: {
                deps: ["rest"],
                get: function(val) {
                    var s = val % 60;
                    var m = Math.floor(val / 60) % 60;
                    var h = Math.floor(val / 3600);

                    return (h ? '' + h + ':' : '') + (h > 0 && m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' + s : s);
                },
            },

            hasLoadValue: {
                deps: ["loadValue"],
                get: function(val) {
                    return this.hasLoadValue();
                }
            },

            repsValue: {
              deps: ['rep'],
              get: function() {
                  return this.get('reps') === 0 ? '' : this.get('reps');
              },
              set: function(value) {
                  this.set('reps', value);
              }
            },
            repsConverted: {
                deps: ['rep'],
                get: function() {
                    return this.get('reps');
                },
                set: function(value) {
                    this.set('reps', Number(value));
                }
            },
        },

        hasLoadValue: function() {
            return this.get('loadValue') !== 0;
        },

        ////////////////
        // validation //
        ////////////////
        validation: {
            reps: {
                presence: false
            },
            "load.value": {
                presence: true,
                numericality: {
                    //onlyInteger: true,
                    greaterThanOrEqualTo: 0,
                    message: "The load must be a positive integer.",
                },
            },
            rest: {
                presence: true,
                numericality: {
                    onlyInteger: true,
                    greaterThanOrEqualTo: 0,
                    message: "The rest time is a positive number of minutes.",
                },
            }

        },

    });

    // Return the model for the module
    return MSet;
});

